import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { Season } from './season.model';
import { SeasonsModalComponent } from '../components/seasons-modal/seasons-modal.component';
import { SeasonModalComponent } from '../components/season-modal/season-modal.component';
import { SeasonTranslationModalComponent } from '../components/season-translation-modal/season-translation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class SeasonModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  openSeasonsModal(successCallback) {
    const options = {
      width: '700px', // 1000px
      minHeight: '80vh',
      maxHeight: '80vh',
      position: { top: '5vh' },
      disableClose: true,
      data: {
        title: 'SEASONS',
      },
      confirmCallback: successCallback,
      // preventCloseOnSave: true,
    };

    this.modalDialogService.open(options, SeasonsModalComponent);
  }

  openSeasonModal(
    season: Season,
    defaultLanguage,
    additionalLanguages,
    mode,
    successCallback = null
  ) {
    const confirmCallback = (result) => {
      // Edit
      if (season.id) {
        season.name = result.name;
        season.from = result.from;
        season.to = result.to;

        return this.utilService.changeItemRowStyle(season.id);
      }

      return successCallback(result);
    };

    const options = {
      disableClose: true,
      data: {
        title: 'SEASON_DETAILS',
        obj: season,
        params: {
          defaultLanguage: defaultLanguage,
          additionalLanguages: additionalLanguages,
          mode: mode,
        },
      },
      confirmCallback: confirmCallback,
    };

    this.modalDialogService.open(options, SeasonModalComponent);
  }

  openSeasonTranslation(season: Season, language: any) {
    const options = {
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'SEASON_DETAILS',
        obj: season,
        params: {
          language: language,
        },
      },
    };

    this.modalDialogService.open(options, SeasonTranslationModalComponent);
  }
}
